import { createPortal } from "react-dom";
import { useTranslation } from "react-i18next";
import logo2 from "../../assets/logo2.png";

const LogoutModal = ({ isOpen, onClose, onConfirm }) => {
  const { t } = useTranslation();
  if (!isOpen) return null;

  return createPortal(
    <div
      className="fixed inset-0 flex items-center justify-center transition-opacity duration-300"
      style={{ zIndex: 99999, backgroundColor: "rgba(0, 0, 0, 0.4)" }}
      onClick={onClose}
    >
      <div
        className="bg-white rounded-xl shadow-2xl p-8 transform transition-all duration-300 scale-100"
        onClick={(e) => e.stopPropagation()}
        style={{ width: "400px" }}
      >
        <div className="flex justify-center mb-4">
          <img src={logo2} alt="AssetEye Logo" className="h-10 w-auto" />
        </div>

        <h2 className="font-bold text-2xl text-center text-[#2d5a43] mb-2">
          {t("logout.logoutConfirmation")}
        </h2>

        <p className="text-center text-gray-500 text-sm mb-8 px-4 leading-relaxed">
          {t("logout.logoutText")}
        </p>

        <div className="flex justify-between gap-4">
          <button
            className="flex-1 border border-gray-300 text-gray-600 font-medium px-2 py-1.5 rounded-lg hover:bg-gray-50 transition-colors"
            onClick={onClose}
          >
            {t("logout.cancel")}
          </button>

          <button
            className="flex-1 border border-[#3D6C50] text-white font-medium px-2 py-1.5 rounded-lg bg-[#3D6C50] transition-colors"
            onClick={onConfirm}
          >
            {t("logout.logout")}
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
};

export default LogoutModal;
